// Contact.jsx
import { Element } from "react-scroll";
import { FaLinkedin, FaEnvelope } from "react-icons/fa";

export default function Contact() {
  return (
    <Element name="contact-section">
      <footer
        id="contact-section"
        className="bg-gray-900 text-gray-300 py-10"
      >
        <div className="max-w-6xl mx-auto px-6">
          <div className="flex flex-col items-center gap-6">
            <h2 className="text-xl font-semibold text-gray-100">Get in Touch</h2>

            <div className="flex gap-8">
              {/* LinkedIn */}
              <a
                href="https://www.linkedin.com/in/nandhinin0506/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-blue-400 transition duration-300 group"
              >
                <FaLinkedin className="text-2xl group-hover:scale-110 transform transition" />
                <span className="hidden sm:inline border-b border-transparent group-hover:border-blue-400">
                  LinkedIn
                </span>
              </a>

              {/* Email */}
              <a
                href="mailto:nandhininandhagopal0506@gmail.com"
                className="flex items-center gap-2 hover:text-red-400 transition duration-300 group"
              >
                <FaEnvelope className="text-2xl group-hover:scale-110 transform transition" />
                <span className="hidden sm:inline border-b border-transparent group-hover:border-red-400">
                  Email
                </span>
              </a>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-6 text-center">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Virtual Keyboard. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </Element>
  );
}